import React from 'react';

import {
  GenericPaginatedList,
  GenericPaginatedListCommonProps,
} from 'app/components/general/lists/GenericPaginatedList';
import {StoredGroupedSignoffFetcher} from 'app/signoffs/datafetchers';

import {TeamGroupedSignoffsListItem} from './TeamGroupedSignoffsListItem';

import type {TeamSerializedType} from 'sweet-types';

interface Props
  extends GenericPaginatedListCommonProps<{
    team_id: number;
    by: string;
    tag?: string;
    search?: string;
    ordering?: 'name' | '-rank';
  }> {
  team: TeamSerializedType;
  groupBy: string;
  refreshList: () => Promise<unknown>;
  ordering: string;
}

export const TeamGroupedSignoffsList = ({
  pageParamName,
  groupBy,
  refreshList,
  team,
  paramsBuilder,
  noItemsMessage,
  ordering,
}: Props) => (
  <GenericPaginatedList
    ItemComponent={TeamGroupedSignoffsListItem}
    FetcherComponent={StoredGroupedSignoffFetcher}
    paramsBuilder={paramsBuilder}
    customProps={() => ({
      team,
      groupBy,
      refreshList,
      ordering,
    })}
    pageParamName={pageParamName}
    noItemsMessage={noItemsMessage}
  />
);
